/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

/**
 * Resolve the signed-in user's bearer token the same way the rest of the app does:
 * prefer localStorage `tk`, fall back to the shared cross-app `VCS_TOKEN` cookie
 * (set by the accounts app). Mirrors the seam used by lib/axiosInstance.js so the
 * assistant authenticates against the same backend.
 */
export const getAuthToken = () => {
  const local = localStorage.getItem("tk");
  if (local) return local;

  const cookies = document.cookie ? document.cookie.split("; ") : [];
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === "VCS_TOKEN") {
      try {
        return decodeURIComponent(value);
      } catch (_) {
        return value;
      }
    }
  }
  return localStorage.getItem("VCS_TOKEN") || null;
};
